import React from 'react';
import { CourseEntity, ICourseEntityAttributes } from 'Models/Entities';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { sharedStyles } from 'Views/Pages/Pdf/styles';

const styles = StyleSheet.create({
	courseAccordionItem: {
		display: 'flex',
		flexDirection: 'column',
	},
	courseDetails: {
		display: 'flex',
		flexDirection: 'row',
		gap: 8,
	},
	requisite: {
		display: 'flex',
		flexDirection: 'row',
		gap: 4,
		marginTop: 8,
	},
	courseCode: {
		flexBasis: '15%',
	},
	courseName: {
		flexBasis: '35%',
	},
	courseLabel: {
		flexBasis: '25%',
	},
	unitCount: {
		flexBasis: '25%',
		display: 'flex',
		flexDirection: 'row',
		gap: 8,
		justifyContent: 'flex-end',
	},
});

interface PdfCourseAccordionItemProps {
	course: ICourseEntityAttributes,
	label?: React.ReactNode,
	additionalStatus?: React.ReactNode,
	showRequisiteDescription?: boolean,
	warning?: React.ReactNode
}

const PdfCourseAccordionItem = (props: PdfCourseAccordionItemProps) => {
	const {
		course,
		label,
		additionalStatus,
		showRequisiteDescription = true,
		warning,
	} = props;

	const topLevelLogicGroup = course.requisiteLogicGroups
		.find(logicGroup => logicGroup.isTopLevelGroup);

	const requisiteDescription = topLevelLogicGroup?.description?.length
		? (
			<Text style={sharedStyles.darkGrey}>
				{topLevelLogicGroup?.description}
			</Text>
		)
		: null;

	return (
		// Disable component wrapping to prevent a small bit of this component from being split to the next page
		<View style={styles.courseAccordionItem} wrap={false}>
			<View style={styles.courseDetails}>
				<View style={styles.courseCode}>
					<Text>{course.code}</Text>
				</View>
				<View style={styles.courseName}>
					<Text>{new CourseEntity(course).getDisplayName()}</Text>
				</View>
				<View style={styles.courseLabel}>
					{label}
				</View>
				<View style={styles.unitCount}>
					{additionalStatus}
					<Text>{course.units} units</Text>
				</View>
			</View>
			<View style={styles.requisite}>
				{/* {Duplicate course code element to push the requisite to the right, under course name} */}
				<View style={styles.courseCode} />
				{showRequisiteDescription && !warning && requisiteDescription}
				{warning}
			</View>
		</View>
	);
};

export default PdfCourseAccordionItem;
